/* Básicos
---------------------------------------------------------------- */
// Existe?
const existe = (elemento, tipo) => {
    if(tipo == 'data') { if(document.querySelectorAll(`[${elemento}]`).length) { return true; } } 
    if(tipo == 'clase') { if(document.querySelectorAll(`.${elemento}`).length) { return true; } }
    if(tipo == 'id') { if(document.querySelectorAll(`#${elemento}`).length) { return true; } }
    if(tipo == 'meta') { if(document.querySelectorAll(`meta[name="${elemento}"]`).length) { return true; } }
}

// Resize timer
function debounce(func){
    let timer;
    return function(event) {
        if(timer) clearTimeout(timer);
        timer = setTimeout(func,200,event);
    };
}

// Is mobile?
function isMobileDevice() { return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1); };

// Is in viewport?
const isElementXPercentInViewport = function(el, percentVisible) {
    let rect = el.getBoundingClientRect(),
        windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    return !(
        Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100)) < percentVisible ||
        Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
    )
};

// Iconos
const insertarIconos = () => {
    const iconos = document.querySelectorAll('i.icono');
    if(iconos.length > 0) {
        fetch('//www.allblkmarket.com/cdn/shop/t/2/assets/iconos.json?v=61244931404391518061627516763').then(respuesta => respuesta.text()).then(datos => {
            datos = JSON.parse(datos);
            for(let i=0; i<iconos.length; i++) {
                let proceder = true;
                if(iconos[i].querySelectorAll('svg').length > 0) { proceder = false; }
                if(proceder) {
                    let icono = iconos[i].getAttribute('data-icono');
                    let path;
                    for(let o=0; o<datos.iconos.length; o++){ if(datos.iconos[o].icono == icono) { path = datos.iconos[o].path; } }
                    let html = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" aria-hidden="true"><path d="${path}"/></svg>`;
                    iconos[i].insertAdjacentHTML('beforeend', html);
                }
            }
        });
    }
}

// Animaciones
const prepararAnimaciones = () => {
    let items = document.querySelectorAll('[data-animacion]');
    for(let i=0; i<items.length; i++) {
        if(items[i].getAttribute('data-animacion') == 'fadeInUp') {
            items[i].style.transform = 'translateY(2rem)';
        }
        items[i].style.opacity = '0';
        items[i].classList.add('animaciones-activado');
    }
}
document.addEventListener('DOMContentLoaded', prepararAnimaciones);

const iniciarAnimaciones = () => {
    let items = document.querySelectorAll('.animaciones-activado');
    for(let i=0; i<items.length; i++) {
        if(isElementXPercentInViewport(items[i], 50)) {
            if(items[i].getAttribute('data-animacion') == 'fadeInUp') {
                items[i].style.transform = '';
            }
            items[i].style.opacity = '';
            setTimeout(function() { items[i].classList.remove('animaciones-activado'); },700);
        }
    }
}
document.addEventListener('scroll', iniciarAnimaciones);

// Preloader
const preloader = () => {
    let preloader = document.querySelector('#preloader');
    if(preloader.getAttribute('data-preloader-sprite-url') == '') { preloader.insertAdjacentHTML('beforeend', '<div class="spinner"></div>'); }
    else { preloader.insertAdjacentHTML('beforeend', `<img src="${preloader.getAttribute('data-preloader-sprite-url')}" style="width:${preloader.getAttribute('data-preloader-sprite-dimension')}px;" alt="Loading" />`); }
    insertarIconos();
    window.addEventListener('load', function() {
        setTimeout(function() {
            preloader.style.opacity = '0';
        }, 250);
        setTimeout(function() {
            preloader.remove();
            iniciarAnimaciones();
        }, 550);
    });

}
document.addEventListener('DOMContentLoaded', preloader);

// Misma Altura
const mismaAltura = () => {
    if(existe('misma-altura', 'clase')) {
        let resetearAltura = document.querySelectorAll('.misma-altura .item');
        for (let i = 0; i < resetearAltura.length; i++) { resetearAltura[i].style.height = ''; }
        const item = document.getElementsByClassName('misma-altura');
        for(let i=0; i<item.length; i++) {
            let limite = 575;
            let altura = 0;
            if(item[i].getAttribute('data-misma-altura-off') !== null) { limite = item[i].getAttribute('data-misma-altura-off'); }
            if(window.innerWidth > limite) {
                const items = item[i].querySelectorAll('.item');
                for(let i=0; i<items.length; i++) { if(items[i].offsetHeight > altura) { altura = items[i].offsetHeight; } }
            }
            let cambiarAltura = item[i].getElementsByClassName('item');
            if(altura > 0) { for (let i = 0; i < cambiarAltura.length; i++) { cambiarAltura[i].style.height = `${altura}px`; } }
        }
    }
}
window.addEventListener('load', mismaAltura);
window.addEventListener('resize', debounce(mismaAltura));

/* Menú
---------------------------------------------------------------- */
const menuPadding = () => {
    let items = document.querySelectorAll('#top div.menu li.principal');
    for(let i=0; i<items.length; i++) {
        items[i].style.paddingLeft = '';
        if(i==items.length-1) { items[i].style.paddingRight = ''; }
    }
    if(window.innerWidth > 991) {
        let anchoItems = 0;
        for(let i=0; i<items.length; i++) { anchoItems += items[i].offsetWidth; }
        let anchoRestante = document.querySelector('#top div.menu').offsetWidth - anchoItems;
        anchoRestante = Math.floor(anchoRestante / (items.length+1));
        for(let i=0; i<items.length; i++) {
            items[i].style.paddingLeft = `${anchoRestante}px`;
            if(i==items.length-1) { items[i].style.paddingRight = `${anchoRestante}px`; }
        }
    }
}
window.addEventListener('load', menuPadding);
window.addEventListener('resize', debounce(menuPadding));

const menuMovil = () => {
    document.querySelector('div.menu-movil-trigger').addEventListener('click', function() {
        if(this.classList.contains('activo')) {
            this.classList.remove('activo');
            document.querySelector('#top div.menu ul').style.opacity = '';
            document.querySelector('#top div.menu ul').style.height = '';
        }
        else {
            this.classList.add('activo');
            document.querySelector('#top div.menu ul').style.opacity = '1';
            document.querySelector('#top div.menu ul').style.height = 'auto';
        }
    });
}
window.addEventListener('load', menuMovil);

const menuCorto = () => {
    if(window.innerWidth > 767 && window.scrollY > window.innerHeight / 3) { document.querySelector('#top').classList.add('corto'); }
    else { document.querySelector('#top').classList.remove('corto'); }
}
document.addEventListener('DOMContentLoaded', menuCorto);
window.addEventListener('scroll', menuCorto);
window.addEventListener('resize', debounce(menuCorto));

const menuCortoMovil = () => {
    if(window.innerWidth <= 575 && window.scrollY > 100) {
        document.querySelector('#top').style.position = 'fixed';
        document.querySelector('#top').style.top = '-100px';
        document.querySelector('body').style.paddingTop = '150px';
    } else {
        document.querySelector('#top').style.position = '';
        document.querySelector('#top').style.top = '';
        document.querySelector('body').style.paddingTop = '';
    }
}
document.addEventListener('DOMContentLoaded', menuCortoMovil);
window.addEventListener('scroll', menuCortoMovil);
window.addEventListener('resize', debounce(menuCortoMovil));

const menuMovilPosicion = () => {
    if(window.innerWidth <= 991) {
        if(window.innerWidth > 575) { document.querySelector('#top div.menu ul').style.top = document.querySelector('#top').offsetHeight + 'px'; }
        else {
            let offsetInicial = 150;
            if(window.scrollY < 100) { offsetInicial -= window.scrollY; }
            else { offsetInicial = 50; }
            document.querySelector('#top div.menu ul').style.top = `${offsetInicial}px`;
        }
        document.querySelector('#top div.menu ul').style.right = (window.innerWidth - document.querySelector('div.container').offsetWidth)/2 + 'px';
    } else {
        document.querySelector('#top div.menu ul').style.top = '';
        document.querySelector('#top div.menu ul').style.right = '';
    }
}
document.addEventListener('DOMContentLoaded', menuMovilPosicion);
window.addEventListener('scroll', menuMovilPosicion);
window.addEventListener('resize', debounce(menuMovilPosicion));

/* Youtube Fullscreen
----------------------------------------------------------------*/
const ytFullscreen = () => {
    if(existe('youtube-embed','clase')) {
        const pods = document.querySelectorAll('.youtube-embed');
        let wrapperH = document.querySelector('.youtube-embed').parentElement.offsetHeight;
        let wrapperW = window.innerWidth;
        for(let i=0; i<pods.length; i++) {
            pods[i].querySelector('div.video').style.width = '';
            pods[i].querySelector('div.video').style.height = '';
        }
        if(wrapperW / wrapperH > 1.7777777777777777) {
            //video debe ser mas ancho
            for(let i=0; i<pods.length; i++) {
                let calculo = wrapperW/1.7777777777777777; calculo = Math.ceil(calculo);
                pods[i].querySelector('div.video').style.width = `${wrapperW}px`;
                pods[i].querySelector('div.video').style.height = `${calculo}px`;
            }
        }
        if(wrapperW / wrapperH < 1.7777777777777777) {
            //video debe ser mas alto
            for(let i=0; i<pods.length; i++) {
                let calculo = wrapperH*1.7777777777777777; calculo = Math.ceil(calculo);
                pods[i].querySelector('div.video').style.width = `${calculo}px`;
                pods[i].querySelector('div.video').style.height = `${wrapperH}px`;
            }
        }
        if(wrapperW / wrapperH == 1.7777777777777777) {
            //video es ideal
            for(let i=0; i<pods.length; i++) {
                pods[i].querySelector('div.video').style.width = '100%';
                pods[i].querySelector('div.video').style.height = '100%';
            }
        }
        if(isMobileDevice(true)) { for(let i=0; i<pods.length; i++) { pods[i].querySelector('div.video').style.display = 'none'; } }
        else { for(let i=0; i<pods.length; i++) { pods[i].querySelector('div.video').style.display = ''; } }
    }
}
window.addEventListener('load', ytFullscreen);
window.addEventListener('resize', ytFullscreen);

/* Tiny Slider
----------------------------------------------------------------*/
const startTiny = () => {
    let items = document.querySelectorAll('.tiny-slider');
    for(let i=0; i<items.length; i++) {
        if(items[i].getAttribute('data-tiny-tipo') === 'slider-principal') {
            var slider = tns({
                container: '.tiny-slider',
                items: 1,
                gutter: 0,
                slideBy: 1,
                autoplay: true,
                controls: true,
                center: true,
                navPosition: 'bottom',
                arrowKeys: true,
                autoplayTimeout: 4000,
                autoHeight: true,
                autoplayButton: false,
                mouseDrag: true,
                autoplayButtonOutput: false
            });
        }
        if(items[i].getAttribute('data-tiny-tipo') === 'slider-featured') {
            var sliderFeatured = tns({
                container: '.tiny-slider-featured',
                items: 1,
                responsive: {
                    992: { items: 4 },
                    551: { items: 3 }
                },
                gutter: 0,
                slideBy: 1,
                autoplay: true,
                controls: false,
                center: false,
                navPosition: 'bottom',
                arrowKeys: true,
                autoplayTimeout: 3000,
                autoHeight: false,
                autoplayButton: false,
                mouseDrag: true,
                autoplayButtonOutput: false,
                loop: true
            });
        }
        if(items[i].getAttribute('data-tiny-tipo') === 'slider-speakers') {
            var sliderSpeakers = tns({
                container: '.tiny-slider-speakers',
                items: 1,
                responsive: {
                    992: { items: 4 },
                    768: { items: 3 },
                    551: { items: 2 }
                },
                gutter: 0,
                slideBy: 1,
                autoplay: true,
                controls: false,
                center: false,
                navPosition: 'bottom',
                arrowKeys: true,
                autoplayTimeout: 5000,
                autoHeight: false,
                autoplayButton: false,
                mouseDrag: true,
                autoplayButtonOutput: false,
                loop: true
            });
          document.querySelector('.speakers-prev').addEventListener('click', function() { sliderSpeakers.goTo('prev'); });
          document.querySelector('.speakers-next').addEventListener('click', function() { sliderSpeakers.goTo('next'); });
        }
        if(items[i].getAttribute('data-tiny-tipo') === 'slider-logos') {
            var sliderSpeakers = tns({
                container: '.tiny-slider-logos',
                items: 1,
                responsive: {
                    992: { items: 4 },
                    768: { items: 3 },
                    551: { items: 2 }
                },
                gutter: 0,
                slideBy: 1,
                autoplay: true,
                controls: false,
                center: false,
                navPosition: 'bottom',
                arrowKeys: true,
                autoplayTimeout: 3000,
                autoHeight: false,
                autoplayButton: false,
                mouseDrag: true,
                autoplayButtonOutput: false,
                loop: true
            });
        }
    }
}

const insertTiny = () => {
    let css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = '//www.allblkmarket.com/cdn/shop/t/2/assets/tiny-slider.css?v=164510136814586918581624641101';
    document.head.appendChild(css);
    let js = document.createElement('script');
    js.src = '//www.allblkmarket.com/cdn/shop/t/2/assets/tiny-slider.js?v=20991146731644069761624641154';
    js.onload =
    setTimeout(() => {
        let items = document.querySelectorAll('.tiny-slider');
        for(let i=0; i<items.length; i++) { startTiny(items[i].getAttribute('data-tiny-tipo')); }
    }, 500);
    document.head.appendChild(css);
    document.body.appendChild(js);
}

window.addEventListener('DOMContentLoaded', function() { if(existe('tiny-slider','clase')) { startTiny(); } } );

/* Shop sidebar
----------------------------------------------------------------*/
const shopSidebar = () => {
    if(existe('sidebar-trigger','clase')) {
        document.querySelector('a.sidebar-trigger').addEventListener('click', function(e) {
            e.preventDefault();
            if(this.classList.contains('activo')) {
                document.querySelector('div.sidebar').style.left = '';
                this.classList.remove('activo');
            }
            else {
                document.querySelector('div.sidebar').style.left = 0;
                this.classList.add('activo');
            }
        });
        document.querySelector('div.sidebar span.cerrar').addEventListener('click', function(e) {
            e.preventDefault();
            document.querySelector('a.sidebar-trigger').click();
        });
    }
}
window.addEventListener('DOMContentLoaded', shopSidebar);

/* Producto Single Imágenes
----------------------------------------------------------------*/
const imgSingle = () => {
    if(existe('previews','clase')) {
        let items = document.querySelectorAll('div.previews ul li a');
        for(let i=0; i<items.length; i++) {
            items[i].addEventListener('click', function(e) {
                e.preventDefault();
                if(items[i].getAttribute('data-tipo') == 'img') {
                    let html = `<img src="${items[i].getAttribute('href')}" />`;
                    document.querySelector('div.featured-img-x').innerHTML = html;
                }
                if(items[i].getAttribute('data-tipo') == 'video-youtube') {
                    let html = `<iframe src="https://www.youtube.com/embed/${items[i].getAttribute('data-video-id')}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
                    document.querySelector('div.featured-img-x').innerHTML = html;
                }
                if(items[i].getAttribute('data-tipo') == 'video-vimeo') {
                    let html = `<iframe src="https://player.vimeo.com/video/${items[i].getAttribute('data-video-id')}" width="640" height="268" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
                    document.querySelector('div.featured-img-x').innerHTML = html;
                }
            });
        }
    }
}
window.addEventListener('DOMContentLoaded', imgSingle);

/* Botón go back
----------------------------------------------------------------*/
const botonBack = () => {
    if(existe('jq-regresar','clase')) {
        let referrer = document.referrer;
        referrer = referrer.replace('https://','');
        referrer = referrer.split('/')[0];
        let sitio = window.location.hostname;
        document.querySelector('a.jq-regresar').addEventListener('click', function(e) {
            e.preventDefault();
            if(referrer == sitio) { window.history.back(); }
            else {  window.location.href = document.querySelector('a.jq-regresar').getAttribute('data-fallback-url'); }
        });
    }
}
window.addEventListener('DOMContentLoaded', botonBack);

/* Carrito
---------------------------------------------------------------- */
const carrito = () => {
    if(existe('row','clase')) {
        let items = document.querySelectorAll('div.cart input.quantity');
        let subtotalItems = document.querySelectorAll('div.total[data-item-precio-total]');
        for(let o=0; o<subtotalItems.length; o++) { subtotalItems[o].setAttribute('data-item-precio-total', subtotalItems[o].getAttribute('data-item-precio-total').replace(',','')); }; 
        for(let i=0; i<items.length; i++) {
            items[i].addEventListener('change', function() {
                if(items[i].value > 0) {
                    // Actualizar el total de cada producto
                    let productoID = items[i].getAttribute('data-producto-id');
                    let productoPrecio = document.querySelector(`div.row[data-item-id="${productoID}"] div.price div.txt-x`).getAttribute('data-item-precio');
                    document.querySelector(`div.row[data-item-id="${productoID}"] div.total div.txt-x`).innerHTML = `$${(items[i].value * productoPrecio).toFixed(2)}`;
                    document.querySelector(`div.row[data-item-id="${productoID}"] div.total div.txt-x`).setAttribute('data-item-precio-total', `${(items[i].value * productoPrecio).toFixed(2)}`);
                    // Actualizar el subtotal de la cuenta
                    let subtotal = 0;
                    let subtotalItems = document.querySelectorAll('div.total div.txt-x[data-item-precio-total]');
                    for(let o=0; o<subtotalItems.length; o++) { subtotal = subtotal + parseFloat(subtotalItems[o].getAttribute('data-item-precio-total')); }
                    document.querySelector('span.subtotal-cantidad').innerHTML = `$${subtotal.toFixed(2)}`;
                    // Mandar actualizaciones a shopify
                    let actualizaciones = `updates[${productoID}]=${items[i].value}`;
                    jQuery.post('/cart/update.js', actualizaciones);
                }
            });
        }
    }
}
window.addEventListener('load', carrito);

/* FAQ
---------------------------------------------------------------- */
const faq = () => {
    if(existe('faq','clase')) {
        const preguntas = document.querySelectorAll('div.pod');
        for(let i=0; i<preguntas.length; i++) {
            preguntas[i].querySelector('h3').addEventListener('click', function() {
                if(preguntas[i].classList.contains('activo')) { preguntas[i].classList.remove('activo'); }
                else { preguntas[i].classList.add('activo'); }
            });
        }
    }
}
window.addEventListener('load', faq);

/* Team
---------------------------------------------------------------- */
const fotoEquipoSingle = () => {
    if(existe('bio-single-header','clase')){
        document.querySelector('div.bio-single-header div.img-x img').setAttribute('src', document.querySelector('div.info img').getAttribute('src'));
        document.querySelector('div.bio-single-txt img').remove();
    }
}
window.addEventListener('DOMContentLoaded', fotoEquipoSingle);

const fotosEquipo = () => {
    if(existe('biografias','clase')){
        const items = document.querySelectorAll('div.biografias div.item');
        for(let i=0; i<items.length; i++) {
            items[i].querySelector('div.img-x img').setAttribute('src', items[i].querySelector('div.img-x div.info img').getAttribute('src'));
        }
    }
}
window.addEventListener('DOMContentLoaded', fotosEquipo);

/* Producto v2 single
---------------------------------------------------------------- */
const productoV2ListaDeImagenes = () => {
    if(existe('lista-de-imagenes-de-producto','clase')) {
        function listaDeImagenes() {
            let altura = document.querySelector('div.producto-single-v2 div.imagenes div.principal div.img').offsetHeight;
            document.querySelector('div.lista-de-imagenes-de-producto').style.height = `${altura}px`;
            if(document.querySelector('div.producto-single-v2 div.imagenes div.altura').offsetHeight > altura) {
                document.querySelector('div.producto-single-v2 div.galeria').classList.add('scrollbar');
                document.querySelector('div.producto-single-v2 div.imagenes div.altura').style.paddingBottom = '3rem';
            } else {
                document.querySelector('div.producto-single-v2 div.galeria').classList.remove('scrollbar');
                document.querySelector('div.producto-single-v2 div.imagenes div.altura').style.paddingBottom = '';
            }
        }
        window.addEventListener('load', listaDeImagenes());
        window.addEventListener('resize', listaDeImagenes());
        let botones = document.querySelectorAll('div.lista-de-imagenes-de-producto div.img a');
        for(let i=0; i<botones.length; i++) {
            botones[i].addEventListener('click', function(e) {
                e.preventDefault();
                document.querySelector('div.producto-single-v2 div.imagenes div.principal img').setAttribute('src', this.getAttribute('href'));
            });
        }
    }

}
window.addEventListener('DOMContentLoaded', productoV2ListaDeImagenes);

/* Precio de variante actualizar
---------------------------------------------------------------- */
const precioDeVariante = () => {
    if(existe('product-select','id')) {
        document.querySelector('#product-select').addEventListener('change', function() {
            document.querySelector('div.product-single div.txt span.precio').innerHTML = this.options[this.selectedIndex].getAttribute('data-precio');
        });
    }
}
window.addEventListener('DOMContentLoaded', precioDeVariante);

/* Parallax imgs
---------------------------------------------------------------- */
var parallaxImgs = document.querySelectorAll('.parallax-img');
new simpleParallax(parallaxImgs);

/* Video lightbox
---------------------------------------------------------------- */
const videoLightbox = () => {
    if(existe('media-news-grid-lightbox','clase')) {
      let botones = document.querySelectorAll('.video-lighbox-url');
      for(let i=0; i<botones.length; i++) {
          botones[i].addEventListener('click', function(e) {
              e.preventDefault();
              let video = `<video controls><source src="${this.getAttribute('href')}" type="video/mp4"></video>`;
              document.querySelector('div.media-news-grid-lightbox div.video').insertAdjacentHTML('afterbegin', video);
              document.querySelector('div.media-news-grid-lightbox').style.display = 'block';
          });
      }
      document.querySelector('div.media-news-grid-lightbox span.cerrar').addEventListener('click', function() {
        document.querySelector('div.media-news-grid-lightbox').style.display = 'none';
        document.querySelector('div.media-news-grid-lightbox div.video video').remove();
      });
    }
}
window.addEventListener('DOMContentLoaded', videoLightbox);